<template>
  <div class="qzList">
    <div class="documentContent">
      <div class="inner">
        <div class="documentInner">
          <div class="screenTop">
            <p class="title">签章管理 <span class="newBtn" @click="newqz"><i>+</i>新建签章</span></p>
          </div>
          <div class="documentListContent">
            <div class="item" v-show="sg.length>0" :class="{mrItem:item.isDefault ==1}" v-for="(item,index) in sg">
              <div class="top">
                <div class="innerImg">
                  <img class="k" :src="item.signUrl" alt="">
                  <span v-show="item.isDefault ==1">
                    <img src="../../assets/images/dh.png"/>
                  </span>
                </div>
                <p class="txt">{{item.name}}</p>
              </div>
              <div class="bottom">
                <span class="mr" v-if="item.isDefault ==1">默认签章</span>
                <span class="bj" style="color:  #245CB3;"@click="del(item)">删除</span>
                <span class="bj" style="color:  #EE532D;" @click="edit(item)">编辑</span>
              </div>
            </div>
            <div class="msg" v-show="sg.length==0">暂无签章，请点击添加</div>
          </div>
        </div>
      </div>
    </div>
    <div class="newLxr" v-show="showWindow">
      <div class="lxrInner">
        <p class="title">{{lxrTitle}}<span class="closeBtn" @click="showWindow = false"></span></p>
        <div class="se1">
          <div class="name">签章名称:</div>
          <el-input v-model="qzmc" placeholder="输入签章名称"></el-input>
        </div>
        <div class="se1">
          <div class="name">是否为默认:</div>
          <el-checkbox v-model="checked">是否为默认</el-checkbox>
        </div>
        <div class="se1" style="padding-bottom: 20px;
          border-bottom: 1px solid rgb(237,237,237);">
          <div class="name" style="vertical-align: top">签章图片:</div>
          <el-upload
            class="avatar-uploader"
            action="http://www.absign.cn:8080/api/common/files/upload"
            :show-file-list="false"
            accept="image/gif, image/jpeg,image/png"
            :on-success="handleAvatarSuccess"
          :before-upload="beforeUpload">
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <p style="width: 80%;margin: 0 auto;font-size: 10px;line-height: 20px;margin-top: 20px">上传您自己的签章。支持的上传格式有：PNG、JPG，GIF，签章最大限制为 500KB</p>
        </div>
        <div class="btns">
          <div class="btn" @click="save">确定</div>
          <div class="btn cancel" @click="showWindow = false">取消</div>
        </div>
      </div>
    </div>
    <div class="newLxr" v-show="showEdit">
      <div class="lxrInner cutWarp">
        <p class="title" style="background:none;margin: 0">编辑图片<span class="closeBtn" @click="showEdit = false"></span></p>
        <div class="cut">
          <VueCropper ref="cropper" :img="editUrl" :output-size="option.size" :output-type="option.outputType" :info="true" :full="option.full"
                      :can-move="option.canMove" :can-move-box="option.canMoveBox" :fixed-box="option.fixedBox" :original="option.original"
                      :auto-crop="option.autoCrop" :auto-crop-width="option.autoCropWidth" :auto-crop-height="option.autoCropHeight" :center-box="option.centerBox"
                      :high="option.high"></VueCropper>
        </div>
        <el-button type="primary" @click="chang(1)">放大</el-button>
        <el-button type="primary" @click="chang(-1)">缩小</el-button>
        <el-button type="primary" @click="down">确定</el-button>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
  import { VueCropper } from 'vue-cropper'
  export default {
    data() {
      return {
        lxrTitle: '新建签章',
        showWindow: false,
        showEdit:false,
        editUrl:'',
        qzmc: "",
        imageUrl: '',
        fireName:'',
        sg: [],
        checked: false,
        eNow: 0,
        option: {
          size:-10,
          full: false,
          outputType: 'png',
          canMove: true,
          fixedBox: false,
          original: false,
          canMoveBox: true,
          autoCrop: true,
          // 只有自动截图开启 宽度高度才生效
          autoCropWidth: 300,
          autoCropHeight: 300,
          centerBox: false,
          high: true
        }
      }
    },
    created() {
      this.getData()
    },
    components:{
      VueCropper
    },
    methods: {
      // 实时预览函数
      down() {
        // event.preventDefault()
        let _this = this;
        this.$refs.cropper.getCropData((data) => {
          _this.ajpost('/api/common/files/uploadBase64',{imgStr:data},function (callBack) {
            console.log(callBack.data)
            _this.imageUrl = callBack.data.image;
            _this.fireName = callBack.data.imageUrl;
            _this.editUrl = callBack.data.image
            _this.showEdit = false;
          },function (err) {
            console.log(err)
          })
        })
      },
      chang(type){
        this.$refs.cropper.changeScale(type)
      },
      handleAvatarSuccess(data) {
        let _this = this;
        this.imageUrl = data.data.imageUrl;
        for(let key in data.data){
          if(key!='imageUrl'){
            _this.fireName = data.data[key];
            _this.editUrl = data.data.imageUrl
            console.log(_this.editUrl)
            _this.showEdit = true;
          }
        }
      },
      beforeUpload(file){
        let _this = this;
        let reader = new FileReader();
        let imgFile;
        reader.onload=function(e) {
          imgFile = e.target.result;
          _this.editUrl =imgFile
          _this.showEdit = true;
        };
        reader.readAsDataURL(file);
        return false;
      },
      getData() {
        let _this = this;
        _this.ajpost('/api/user/findSignList', {}, function (data) {
          _this.sg = data.data||[]
        })
      },
      edit(item) {
        this.qzmc = item.name;
        this.fireName = item.signUrl.split('http://absign.oss-cn-beijing.aliyuncs.com/')[1];
        this.imageUrl = item.signUrl;
        this.checked = (item.isDefault == 0) ? false : true;
        this.showWindow = true;
        this.eNow = item.id;
      },
      newqz(){
        this.showWindow = true;
        this.qzmc = '';
        this.imageUrl = '';
        this.checked = false;
        this.eNow = 0;
      },
      save() {
        if (this.qzmc == '') {
          this.$message({
            message: '请填写签章名称！',
            type: 'warning'
          });
        } else if (this.fireName == '') {
          this.$message({
            message: '请上传签章图片！',
            type: 'warning'
          });
        } else {
          let _this = this,
            data = {
              "isDefault": (_this.checked) ? 1 : 0,
              "name": _this.qzmc,
              "url": _this.fireName.split('?')[0]
            };
          let url = '/api/user/addSign';
          if (_this.eNow != 0) {
            data.id = _this.eNow;
            url = '/api/user/updateSign'
          }
          _this.ajpost(url, data, function (data) {
            if (data.code != 0) {
              _this.$message({
                message: data.msg,
                type: 'warning'
              });
            } else {
              _this.$message({
                message: '操作成功',
                type: 'success'
              });
              _this.showWindow = false;
              _this.qzmc = "";
              _this.imageUrl = '';
              _this.fireName = '';
              _this.checked = false;
              _this.eNow = 0;
              _this.getData()
            }
          })
        }
      },
      del(item){
        let _this = this;
        _this.$confirm('您是否要删除该签章?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _this.ajpost('/api/user/deleteSign',{id:item.id},function (data) {
            if(data.code!=0){
              _this.$message({
                type: 'warning',
                message:data.msg
              });
            }else {
              _this.$message({
                type: 'success',
                message:'删除成功'
              });
              _this.getData()
            }
          },function (err) {
          })
        }).catch(() => {
        });
      }
    }
  }
</script>
<style>
  @import "../../assets/less/qz.css";
</style>



// WEBPACK FOOTER //
// src/components/userCenter/qz.vue